import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { PRINCIPAL_STATES_OPTIONS } from '../../../constants';

const PrincipalState = ({ value }) => {
  const state = useMemo(() => PRINCIPAL_STATES_OPTIONS.find(s => s.value === value)?.text, [value]);

  return <span>{state}</span>;
};

PrincipalState.propTypes = { value: PropTypes.string.isRequired };

export default PrincipalState;
